import { render, staticRenderFns } from "./FileGroup.vue?vue&type=template&id=79dc0352&scoped=true&"
import script from "./FileGroup.vue?vue&type=script&lang=js&"
export * from "./FileGroup.vue?vue&type=script&lang=js&"
import style0 from "./FileGroup.vue?vue&type=style&index=0&id=79dc0352&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dc0352",
  null
  
)

export default component.exports